import { DE_DE } from './de';
export const useI18n = () => {
    return DE_DE;
};
